/**
 * Shared conversion factors and utility functions for tools
 */

export const flowConversionFactors = {
    cubicMeterHour: 1,
    literHour: 1000,
    gallonHour: 264.172052,
    barrelHour: 6.28981077,
};

export const lengthConversionFactors = {
    meter: 1,
    inches: 39.37,
    feet: 3.28084,
    nauticalMiles: 1 / 1852,
};

export const pressureConversionFactors = {
    bar: 1,
    kgCm2: 1.019716213,
    pascal: 100000,
    kiloPascal: 100,
    megaPascal: 0.1,
    mmHg: 750.0616827,
    psi: 14.503773773,
};

export const viscosityConversionFactors = {
    mmHgInmPa: 0.000007500616,
    kPaInmPa: 0.000001,
};

export const volumeConversionFactors = {
    cubicMeter: 1,
    liter: 1000,
    gallons: 264.172052,
    cubicFeet: 35.3146667,
    barrel: 6.28981077,
};

/**
 * Helper function to remove trailing zeros and format numbers
 */
export const formatNumber = (value: number, precision: number = 3): string => {
    return parseFloat(value.toFixed(precision)).toString();
};
